// extracted by mini-css-extract-plugin
export default {"productGallery":"fF-z","inQuickShop":"gF-z"};